import { root, id } from './stop';

export const stop = {
  ...root,
  id,
};
